import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BusinessFacadeService } from '@services/business/business-facade.service';
import { ReportsFacadeService } from '@services/reports/reports-facade.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AppFacadeService } from '@services/app-facade.service';
import { RouterFacadeService } from '@services/router-facade.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.sass']
})
export class ReportsComponent implements OnInit, OnDestroy {
  _subs = new Subscription()

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private businessFacadeService: BusinessFacadeService,
    private reportsFacadeService: ReportsFacadeService,
    private appFacadeService: AppFacadeService,
    private routerFacade: RouterFacadeService
  ) { 
    this._subs.add(
      this.router.events.subscribe(_ => {
        const report = this.activatedRoute.snapshot.queryParamMap.get('report');
        const businessId = this.activatedRoute.snapshot.queryParamMap.get('businessId');

        if (['daily', 'feedback', 'general', 'users'].includes(report)) {
          this.businessFacadeService.searchBusinessById(businessId)
        }
      })
    );
  }

  ngOnInit() {
    this._subs.add(
      this.businessFacadeService.getSelectedBusiness$().pipe(
        filter(business => business && !!business.id)
      ).subscribe(business => {
        this.businessFacadeService.selectBusinessProfile(business)
        this.appFacadeService.searchResellerByBusiness(business.resellerId)

        switch (this.activatedRoute.snapshot.queryParamMap.get('report')) {
          case 'daily':
          case 'feedback':
            this.routerFacade.navigateTo$('/admin-business/dashboard');
            break;
          case 'users':
            this.routerFacade.navigateTo$('/admin-business/users');
            break;
          case 'general':
            this.reportsFacadeService.setGeneralReportDateRange({
              startTime: Number(this.activatedRoute.snapshot.queryParamMap.get('startTime')), 
              endTime: Number(this.activatedRoute.snapshot.queryParamMap.get('endTime'))
            })
            this.routerFacade.navigateTo$('/admin-business/reports');
            break;
        }
      })
    );
  }

  ngOnDestroy() {
    if (this._subs) this._subs.unsubscribe()
  }
}
